module.exports = __webpack_public_path__ + "img/5-1.8780b96c.jpg";